export const PRODUCT_LAYOUT_VIEWS = {
    LIST_VIEW: 'List view',
    GRID_VIEW: 'Grid view',
    SPLIT_VIEW_ROOMS: 'Split view - Rooms',
    SPLIT_VIEW_RATES: 'Split view - Rates'
};

export const IN_CONTEXT_PRODUCT_LAYOUT_VIEWS = {
    ROOM_VIEW: 'Room view',
    RATE_VIEW: 'Rate view',
    CARD_VIEW: 'Card view'
};

export const IN_CONTEXT_DISPLAY_TYPES = {
    ROOM_VIEW: 'inContextRoomView',
    RATE_VIEW: 'inContextRateView',
    CARD_VIEW: 'inContextCardView'
};

export const ROOM_SETTINGS = 'Room Settings';
export const GENERAL = 'General';

export const IN_CONTEXT_RESUME_BOOKING_MESSAGE = {
    BOTTOM_LEFT: 'Bottom left',
    BOTTOM_CENTER: 'Bottom center',
    BOTTOM_RIGHT: 'Bottom right'
};

export const IN_CONTEXT_OVERLAY_WIDTH = {
    FULL_PAGE: 'Bottom: displays full width of screen from the bottom edge',
    TABLET_SIZE: 'Right: displays full height of screen from the right edge',
};

export const IN_CONTEXT_ROOM_CATEGORY_MESSAGE = 'Category views are available when you have categories set up in SynXis CRS';

export const layoutSettingsTypeLabelView = {
    listView: 'List and Grid',
    cardView: 'List and Grid',
    splitView: 'Rooms and Rates'
};

export const LAYOUT_VIEW_SETTINGS_LABELS = {
    ROOMS_SUITES: 'Show Toggle Option Between Rooms and Suites View',
    NO_TOGGLE_OPTION: `Don't Show Any Toggle Option`
};

export const shoppingCartExpirationDays = [
    { key: 1, label: '1 day' },
    { key: 7, label: '7 days' },
    { key: 10, label: '10 days' },
    { key: 15, label: '15 days' },
    { key: 30, label: '30 days' }
];

export const inContextNoOfProductsToExpand = [
    { key: '0', label: '0' },
    { key: '1', label: '1' },
    { key: '2', label: '2' },
    { key: '3', label: '3' },
    { key: 'all', label: 'All' },
];



// WEBPACK FOOTER //
// ./src/constants/RoomsConfiguration.js